import type CK from '~/types/contentking';

import useAccountWebsiteSizes from '~/hooks/useAccountWebsiteSizes';



function useAccountWebsiteCount(accountId: CK.AccountId | null): number | null {
	const websiteSizes = useAccountWebsiteSizes(accountId);

	if (websiteSizes === null) {
		return null;
	}

	return websiteSizes.websites.filter((website) => !website.isArchived).length;
}



export default useAccountWebsiteCount;
